import { useContext } from 'react';

import { ShopProviderContext } from './provider';
import type { ShopProviderContext as ShopProviderContextType } from './provider.types';

const useShopProvider = () => {
  const context = useContext(ShopProviderContext);
  if (!context) {
    return {} satisfies ShopProviderContextType;
  }
  return context;
};

export { useShopProvider };
